import BaseApi from "../../services/baseApi";

class Reporting {

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/reportPyment/list',
            headers: {'Content-Type': 'application/json'},
        })
    }

    search(params){
        // let formData=new FormData();
        // formData.set("buildingIds",buildingIds)
        // formData.set("pGatway",pGatway)
        // formData.set("pStatus",pStatus)
        // formData.set("dateFrom",dateFrom)
        // formData.set("dateTo",dateTo)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:params,
            url: '/private/reportPyment/search',
            headers: {'Content-Type': 'application/json'},
        })

     }



}
export default new Reporting();
